import { isNumeric } from 'utils/utils'

export function isOpenOrShort(ls) {
  return ls === 65534 || ls === 65535
}

export function formatTimeForDisplay(value) {
  // returns an object formatted as: { hours: HH, minutes: MM, seconds: SS.S }
  // value is in tenths of a second. 36000 = 1 hr, 600 = 1 minute, 10 = 1 second
  const hours = parseInt(value / 36000, 10)
  const minutes = parseInt((value - hours * 36000) / 600, 10)
  const seconds = ((value - hours * 36000 - minutes * 600) / 10).toFixed(1)
  return { hours, minutes, seconds }
}

export function formatTimeForApi(hours, minutes, seconds) {
  // returned parsed time as an aggregate representation of 10'ths of a second.
  // 36000 = 1 hr, 600 = 1 minute, 10 = 1 second
  return (
    (isNumeric(hours) && hours * 36000) +
    (isNumeric(minutes) && minutes * 600) +
    (isNumeric(seconds) && seconds * 10)
  )
}
